import {
    HEADER_BACKGROUND_COLOR,
    SKELETON_COL_COUNT,
    SKELETON_ROW_COUNT,
    SKELETON_ROW_HEIGHT,
} from '@/components/decisionSupport/tables/RecommendationsTable.styled';
import { SimpleSkeleton } from '@/fetching/suspense';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { FC } from 'react';

const SkeletonHeader: FC = () => (
    <TableRow>
        {Array.from({ length: SKELETON_COL_COUNT }, (_, i) => (
            <TableCell
                key={i}
                sx={{
                    backgroundColor: HEADER_BACKGROUND_COLOR,
                    borderBottom: 'none',
                }}
            >
                <Box sx={{ width: '100%' }}>
                    <SimpleSkeleton height={SKELETON_ROW_HEIGHT} width='100%' />
                </Box>
            </TableCell>
        ))}
    </TableRow>
);

const SkeletonBody: FC = () => (
    <>
        {Array.from({ length: SKELETON_ROW_COUNT }, (_, rowIdx) => (
            <TableRow key={rowIdx}>
                {Array.from({ length: SKELETON_COL_COUNT }, (_, colIdx) => (
                    <TableCell key={colIdx} sx={{ borderBottom: 'none' }}>
                        <Box sx={{ width: '100%' }}>
                            <SimpleSkeleton height={SKELETON_ROW_HEIGHT} width='100%' />
                        </Box>
                    </TableCell>
                ))}
            </TableRow>
        ))}
    </>
);

export const RecommendationsTableSkeleton: FC = () => (
    <TableContainer>
        <Table>
            <TableHead>
                <SkeletonHeader />
            </TableHead>
            <TableBody>
                <SkeletonBody />
            </TableBody>
        </Table>
    </TableContainer>
);
